import React, { useState } from "react";
import Grid from "@mui/material/Grid2";
import validator from "validator";
import axios from "axios";
import { useSnackbar } from "notistack";
import { useTranslation } from "react-i18next";
import { defaultVariables } from "../../../../config";
import MobileField from "../../../components/elements/fields/MobileField";
import LoadingButton from "../../../components/elements/LoadingButton";

const MarketingChooseMobile = ({ setRep, setNextLevel }) => {
    const { enqueueSnackbar } = useSnackbar();
    const { t } = useTranslation();
    const [fields, setFields] = useState({ mobile: "", country: null });
    const [errors, setErrors] = useState({});
    const [submitLoading, setSubmitLoading] = useState(false);

    const setMobile = (country, mobile) => {
        setFields({ country, mobile });
        setErrors({});
    };

    const validateFields = () => {
        const newErrors = {};
        let formIsValid = true;

        if (!validator.isNumeric(fields.mobile) || fields.mobile.length < 9) {
            formIsValid = false;
            newErrors.mobile = t("wrongMobile");
        }

        setErrors(newErrors);
        return formIsValid;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setSubmitLoading(true);

        if (!validateFields()) {
            setSubmitLoading(false);
            return;
        }

        const data = new FormData();
        let mobile = Number(fields.mobile).toString();
        mobile = fields.country?.phonecode + mobile;
        data.append("mobile", mobile);
        data.append("code", fields.country?.phonecode);

        try {
            const response = await axios.post(`${defaultVariables.url}/marketing/auth/send-otp`, data, {
                headers: { Accept: "application/json" },
            });
            await setRep(response.data);
            await setNextLevel();
        } catch (error) {
            if (error.response?.status === 404) {
                enqueueSnackbar(t("marketingRepNotFound"), { variant: "error" });
            } else {
                enqueueSnackbar(t("wrongMobile"), { variant: "error" });
            }
        } finally {
            setSubmitLoading(false);
        }
    };

    return (
        <form noValidate onSubmit={handleSubmit}>
            <Grid container spacing={2}>
                <Grid item size={12}>
                    <MobileField setMobile={setMobile} error={errors.mobile} />
                </Grid>
                <Grid item size={12}>
                    <LoadingButton
                        type="submit"
                        variant="contained"
                        color="primary"
                        size="large"
                        fullWidth
                        loading={submitLoading}
                        style={{ width: "100%" }}
                        styleForParent={{ margin: "10px 0" }}
                    >
                        {t("continue")}
                    </LoadingButton>
                </Grid>
            </Grid>
        </form>
    );
};

export default MarketingChooseMobile;
